export default __webpack_public_path__ + "static/media/list-view.ecc67b6b.svg";